import { isEmpty, isNaN, isNumber } from 'lodash-es';

/**
 * Checks if value is not empty.
 * A value is considered empty unless it’s an arguments object, array, string,
 * or jQuery-like collection with a length greater than 0 or an object with own enumerable properties.
 * @param value
 * @returns
 */
const notEmpty = <Data>(value: Data): value is NonNullable<Data> => (isNumber(value) && !isNaN(value)) || !isEmpty(value);

export default notEmpty;
